(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let currentTrios = null;
  let originalNextSection = null;

  const syncSectionOrder = () => {
    const main = document.getElementById('MainContent');
    const trios = main?.querySelector('.sunshine-bundles')?.closest('.shopify-section');
    const build = main?.querySelector('[id$="__rich_text_KLFxJA"]');

    if (!main || !trios || !build || trios.parentElement !== main || build.parentElement !== main) return;

    if (trios !== currentTrios) {
      currentTrios = trios;
      originalNextSection = trios.nextElementSibling;
    }

    if (mobile.matches) {
      if (build.previousElementSibling !== trios) main.insertBefore(trios, build);
    } else if (originalNextSection?.parentElement === main) {
      if (trios.nextElementSibling !== originalNextSection) main.insertBefore(trios, originalNextSection);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSectionOrder, { once: true });
  } else {
    syncSectionOrder();
  }

  mobile.addEventListener('change', syncSectionOrder);
  document.addEventListener('shopify:section:load', syncSectionOrder);
})();
